export const ADDRESS_SEARCH_QUERY_MIN_LENGTH = 3;
